import React from 'react';

// aus museum using 10px on html
export const pixelToRem = num => `${num / 10}rem`;

export const H1 = props => (
  <h1
    css={{
      fontWeight: 'bold',
      fontSize: pixelToRem(50),
      lineHeight: '60pt',
    }}
    {...props}
  >
    {props.children}
  </h1>
);
export const H2 = props => (
  <h2
    css={{
      fontWeight: 'bold',
      fontSize: pixelToRem(22),
      lineHeight: '26pt',
    }}
    {...props}
  >
    {props.children}
  </h2>
);
export const P = props => (
  <p
    css={{
      fontWeight: 'bold',
      fontSize: pixelToRem(18),
      lineHeight: '24pt',
    }}
    {...props}
  >
    {props.children}
  </p>
);
export const H3 = props => (
  <h3
    css={{
      fontWeight: 'bold',
      fontSize: pixelToRem(16),
      lineHeight: '22pt',
    }}
    {...props}
  >
    {props.children}
  </h3>
);
export const H4 = props => (
  <h4
    css={{
      fontWeight: 'bold',
      fontSize: pixelToRem(14),
      lineHeight: '22pt',
    }}
    {...props}
  >
    {props.children}
  </h4>
);
export const Span = props => (
  <span
    css={{
      fontWeight: 'bold',
      fontSize: pixelToRem(12),
      lineHeight: '18pt',
    }}
    {...props}
  >
    {props.children}
  </span>
);
